import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import { FaHeart, FaChurch, FaGlassCheers, FaMapMarkerAlt, FaPhone, FaEnvelope, FaRegCalendarAlt, FaClock, FaBus, FaHotel, FaCamera } from 'react-icons/fa';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { CookieConsent } from 'react-cookie-consent';
import './WeddingPage.css';

function formatDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('es-ES', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });
}

function formatTime(s) {
  if (!s) return '';
  const [h, m] = s.split(':');
  return `${h}:${m}`;
}

function useCountdown(target) {
  const [left, setLeft] = useState(null);
  useEffect(() => {
    if (!target) return;
    const t = new Date(target).getTime();
    const tick = () => {
      const d = t - new Date().getTime();
      if (d <= 0) { setLeft({ d: 0, h: 0, m: 0 }); return; }
      setLeft({ d: Math.floor(d / 86400000), h: Math.floor((d / 3600000) % 24), m: Math.floor((d / 60000) % 60) });
    };
    tick(); const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);
  return left;
}

export const WeddingPage = ({ card }) => {
  const { domain } = useParams();
  const cd = useCountdown(card?.wedding_date);
  const s = card?.wedding_settings || {};

  const vars = {
    '--wp-bg': s.backgroundColor || '#FAFAF8',
    '--wp-accent': s.buttonsColor || '#9baf8a',
    '--wp-text': s.descriptionTextColor || '#6A3B2E',
    '--wp-text-light': s.buttonsTextColor || '#FFFFFF',
    '--wp-border': s.buttonsBorderColor || s.backgroundColor || '#d8d8d6',
  };

  const images = [];
  for (let i = 1; i <= 4; i++) {
    if (card?.[`image${i}`]) images.push(card[`image${i}`]);
  }

  return (
    <div className="wp-page" style={vars}>
      <div className="wp-card">

        <header className="wp-header">
          <p className="wp-subtitle">Boda</p>
          <h1 className="wp-couple">
            {card?.bride_name || ''}<br /><span className="wp-amp">&amp;</span><br />{card?.groom_name || ''}
          </h1>
          <p className="wp-date-line">
            <FaRegCalendarAlt /> {formatDate(card?.wedding_date)}
          </p>
          {card?.subtitle && <p className="wp-sub">{card.subtitle}</p>}
        </header>

        {(card?.phone || card?.email) && (
          <div className="wp-pills">
            {card?.phone && (
              <a href={`tel:${card.phone.replace(/[+ ]/g, '')}`} className="wp-pill">
                <FaPhone /> Llamar
              </a>
            )}
            {card?.email && (
              <a href={`mailto:${card.email}`} className="wp-pill">
                <FaEnvelope /> Email
              </a>
            )}
          </div>
        )}

        {card?.story && (
          <section className="wp-section">
            <FaHeart className="wp-icon-heart" />
            <p className="wp-story">{card.story}</p>
          </section>
        )}

        <hr className="wp-hr" />

        <section className="wp-section">
          <FaChurch className="wp-section-icon" />
          <h2 className="wp-section-title">Ceremonia</h2>
          {card?.ceremony_venue && <h3 className="wp-venue">{card.ceremony_venue}</h3>}
          {card?.ceremony_address && <p className="wp-addr"><FaMapMarkerAlt /> {card.ceremony_address}</p>}
          {card?.ceremony_time && <p className="wp-time"><FaClock /> {formatTime(card.ceremony_time)}</p>}
          {card?.ceremony_map_link && (
            <a href={card.ceremony_map_link} target="_blank" rel="noreferrer" className="wp-btn">Cómo llegar</a>
          )}
        </section>

        <hr className="wp-hr" />

        {card?.celebration_venue && (
          <>
            <section className="wp-section">
              <FaGlassCheers className="wp-section-icon" />
              <h2 className="wp-section-title">Celebración</h2>
              <h3 className="wp-venue">{card.celebration_venue}</h3>
              {card?.celebration_address && <p className="wp-addr"><FaMapMarkerAlt /> {card.celebration_address}</p>}
              {card?.party_time && <p className="wp-time"><FaClock /> {formatTime(card.party_time)}</p>}
              {card?.celebration_map_link && (
                <a href={card.celebration_map_link} target="_blank" rel="noreferrer" className="wp-btn">Cómo llegar</a>
              )}
            </section>
            <hr className="wp-hr" />
          </>
        )}

        {card?.dress_code && (
          <>
            <section className="wp-section">
              <h2 className="wp-section-title">Código de vestimenta</h2>
              <p className="wp-dress">{card.dress_code}</p>
            </section>
            <hr className="wp-hr" />
          </>
        )}

        {card?.transport_info && (
          <>
            <section className="wp-section">
              <FaBus className="wp-section-icon" />
              <h2 className="wp-section-title">Transporte</h2>
              <p className="wp-body">{card.transport_info}</p>
            </section>
            <hr className="wp-hr" />
          </>
        )}

        {card?.accommodation_info && (
          <>
            <section className="wp-section">
              <FaHotel className="wp-section-icon" />
              <h2 className="wp-section-title">Alojamiento</h2>
              <p className="wp-body">{card.accommodation_info}</p>
            </section>
            <hr className="wp-hr" />
          </>
        )}

        {(card?.ceremony_time || card?.party_time) && (
          <>
            <section className="wp-section">
              <h2 className="wp-section-title">Itinerario</h2>
              <div className="wp-timeline">
                {card?.ceremony_time && (
                  <div className="wp-tl-item">
                    <div className="wp-tl-dot" />
                    <div className="wp-tl-content">
                      <p className="wp-tl-time">{formatTime(card.ceremony_time)}</p>
                      <p className="wp-tl-label">Ceremonia</p>
                    </div>
                  </div>
                )}
                {card?.party_time && (
                  <div className="wp-tl-item">
                    <div className="wp-tl-dot" />
                    <div className="wp-tl-content">
                      <p className="wp-tl-time">{formatTime(card.party_time)}</p>
                      <p className="wp-tl-label">Celebración</p>
                    </div>
                  </div>
                )}
              </div>
            </section>
            <hr className="wp-hr" />
          </>
        )}

        {images.length > 0 && (
          <>
            <section className="wp-section">
              <FaCamera className="wp-section-icon" />
              <h2 className="wp-section-title">Galería</h2>
              <Carousel showThumbs={false} infiniteLoop useKeyboardArrows autoPlay>
                {images.map((src, i) => (
                  <div key={i}><Image src={src} alt={`Foto ${i + 1}`} className="wp-gallery-img" /></div>
                ))}
              </Carousel>
            </section>
            <hr className="wp-hr" />
          </>
        )}

        {cd && (
          <>
            <section className="wp-section">
              <h2 className="wp-section-title">Cuenta atrás</h2>
              <div className="wp-cd">
                <div className="wp-cd-item">
                  <span className="wp-cd-num">{cd.d}</span>
                  <span className="wp-cd-label">días</span>
                </div>
                <div className="wp-cd-item">
                  <span className="wp-cd-num">{cd.h}</span>
                  <span className="wp-cd-label">horas</span>
                </div>
                <div className="wp-cd-item">
                  <span className="wp-cd-num">{cd.m}</span>
                  <span className="wp-cd-label">min</span>
                </div>
              </div>
            </section>
            <hr className="wp-hr" />
          </>
        )}

        <section className="wp-section">
          <h2 className="wp-section-title">Confirmar asistencia</h2>
          <p className="wp-body">¿Contamos contigo? Confírmanos tu asistencia para poder organizar todo.</p>
          {card?.token && (
            <Link to={`/${domain}/invites?token=${card.token}`} className="wp-btn">
              Confirmar asistencia
            </Link>
          )}
        </section>

        <hr className="wp-hr" />

        {card?.closing_text && (
          <section className="wp-section">
            <FaHeart className="wp-icon-heart" />
            <p className="wp-closing">{card.closing_text}</p>
          </section>
        )}

        <CookieConsent
          buttonText="ACEPTAR"
          cookieName="TDSURCOOKIE"
          declineButtonText="RECHAZAR"
          declineCookieValue="tdsur_declined"
          setDeclineCookie enableDeclineButton
          style={{ background: 'black', border: 'white 2px' }}
          buttonStyle={{ background: 'white', color: 'black', fontWeight: 'bold' }}
        >
          Este sitio web usa cookies para mejorar su experiencia{' '}
          <span style={{ fontSize: '12px' }}>Usted puede aceptar o rechazar su uso en cualquier momento de acuerdo con nuestra política de privacidad y cookies</span>
        </CookieConsent>
      </div>
    </div>
  );
};
